import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import CorporateLandingPage from "pages/corporate-landing-page";
import DiagnosticConsultationRequest from "pages/diagnostic-consultation-request";
import ErpSolutionsShowcase from "pages/erp-solutions-showcase";
import ContactAndConsultationBooking from "pages/contact-and-consultation-booking";
import NotFound from "pages/NotFound";
import { PAGES, LEGACY_REDIRECTS } from "./seo/site";

// Árbol de rutas sin el router -- el navegador lo envuelve en BrowserRouter
// y el prerender del build (src/entry-server.jsx) en StaticRouter.
export const AppRoutes = () => (
  <ErrorBoundary>
    <ScrollToTop />
    <RouterRoutes>
      <Route path={PAGES.home.path} element={<CorporateLandingPage />} />
      <Route path={PAGES.services.path} element={<ErpSolutionsShowcase />} />
      <Route path={PAGES.diagnostic.path} element={<DiagnosticConsultationRequest />} />
      <Route path={PAGES.contact.path} element={<ContactAndConsultationBooking />} />
      {/* URLs anteriores: en producción Cloudflare ya responde 301
          (public/_redirects); esto cubre la navegación dentro de la app */}
      {Object.entries(LEGACY_REDIRECTS).map(([from, to]) => (
        <Route key={from} path={from} element={<Navigate to={to} replace />} />
      ))}
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  </ErrorBoundary>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default Routes;
